const codes = {
  CAMPAIGN_STEP_TYPE_CHANGED: 'CAMPAIGN_STEP_TYPE_CHANGED',
  MARKET_PRODUCT_UPDATED: 'MARKET_PRODUCT_UPDATED',
  DISPLAY_PROFILE_DIALOG: 'DISPLAY_PROFILE_DIALOG'
};

export default codes;